<div class="stpr_cntnt_mn2">
  <div class="edit_question_modal chs_member_modal" style="margin-top: 22px">
    <div class="modal_title">
      <div class="s_head flex">
        <div class="flex">
          <figure>
            <img
              [src]="assetsConst.member"
              style="filter: brightness(0)"
              alt="icon"
            />
          </figure>
          <h2>{{ currentStep === 1 ? 'Select Purchase' : 'Choose Members' }}</h2>
        </div>
      </div>

      <p-button
        class="close_modal"
        (click)="closeDialog()"
        icon="pi pi-times"
        role="button"
        tabIndex="1"
      >
      </p-button>
    </div>

    <!-- Step Indicator -->
    <!-- <div class="steps-indicator mb-4">
      <div class="flex align-items-center justify-content-center gap-4">
        <div class="step-item" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
          <span class="step-number">1</span>
          <span class="step-label">Select Purchase</span>
        </div>
        <div class="step-divider"></div>
        <div class="step-item" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
          <span class="step-number">2</span>
          <span class="step-label">Assign Members</span>
        </div>
      </div>
    </div> -->

    <!-- Step 1: Purchase Selection -->
    <div class="purchase-selection-step" *ngIf="currentStep === 1">
      <p>Select an exam and license type to assign seats from</p>
      
      <div class="whiteBox table_responsive">
        <p-table
          [value]="purchaseList"
          [rows]="10"
          [showCurrentPageReport]="true"
          [paginator]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          selectionMode="single"
          [(selection)]="selectedPurchase"
          dataKey="_id"
        >
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">Select</th>
              <th scope="col">Exam Title</th>
              <th scope="col">Total Seats</th>
              <th scope="col">Seats Filled</th>
              <th scope="col">Available Seats</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-purchase>
            <tr [pSelectableRow]="purchase">
              <td>
                <p-radioButton
                  [name]="'purchase'"
                  [value]="purchase"
                  [(ngModel)]="selectedPurchase"
                  [inputId]="purchase._id"
                >
                </p-radioButton>
              </td>
              <td>
                <div>
                  <p>{{ purchase.practiceSet?.title }}</p>
                  <span class="text-sm block">{{ purchase.practiceSet?.description }}</span>
                </div>
              </td>
              <td>{{ purchase.seats }}</td>
              <td>{{ purchase.seatsFilled }}</td>
              <td>
                <span [class.text-danger]="(purchase.seats - purchase.seatsFilled) <= 0">
                  {{ purchase.seats - purchase.seatsFilled }}
                </span>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="text-center">No purchases found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="btn_flex mt_30 spc_btwn">
        <p-button
          variant="outlined"
          label="Cancel"
          (click)="closeDialog()"
          role="button"
        >
        </p-button>
        <p-button
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          (click)="proceedToMemberSelection()"
          [disabled]="!selectedPurchase"
          role="button"
        >
        </p-button>
      </div>
    </div>

    <!-- Step 2: Member Assignment -->
    <div class="member-assignment-step" *ngIf="currentStep === 2">
      <div class="selected-purchase-info mb-3 p-3 border-round bg-primary-50">
        <div class="flex justify-content-between align-items-center">
          <div>
            <strong>Selected Exam:</strong> {{ selectedPurchase?.practiceSet?.title }}
            <span class="ml-3">
              <strong>Available Seats:</strong> 
              {{ selectedPurchase ? (selectedPurchase.seats - selectedPurchase.seatsFilled) : 0 }}
            </span>
          </div>
          <p-button
            variant="text"
            label="Change"
            icon="pi pi-pencil"
            size="small"
            (click)="backToPurchaseSelection()"
          >
          </p-button>
        </div>
      </div>

      <p>Choose members to assign seats</p>
      
      <div class="filter_section mb-4">
        <div class="flex-row">
          <div class="field flex-item">
            <label for="assignmentType">Assignment Type</label>
            <p-dropdown
              inputId="assignmentType"
              [options]="assignmentTypes"
              [(ngModel)]="selectedAssignmentType"
              placeholder="Select Type"
              optionLabel="name"
              optionValue="value"
              [style]="{ width: '100%' }"
              (onChange)="onAssignmentTypeChange()"
            >
            </p-dropdown>
          </div>

          <div
            class="field flex-item"
            *ngIf="selectedAssignmentType === 'department'"
          >
            <label for="department">Department</label>
            <p-multiselect
              inputId="department"
              [options]="departments"
              [(ngModel)]="selectedDepartments"
              placeholder="Select Departments"
              optionLabel="name"
              optionValue="value"
              [style]="{ width: '100%' }"
              display="chip"
              (onChange)="filterByDepartment()"
            >
            </p-multiselect>
          </div>
        </div>

        <div class="flex-row date-row">
          <div class="field flex-item">
            <label for="startDate">Start Date</label>
            <p-calendar
              inputId="startDate"
              [(ngModel)]="startDate"
              [showIcon]="true"
              placeholder="Select Start Date"
              dateFormat="mm/dd/yy"
              [style]="{ width: '100%' }"
            >
            </p-calendar>
          </div>

          <div class="field flex-item">
            <label for="endDate">End Date</label>
            <p-calendar
              inputId="endDate"
              [(ngModel)]="endDate"
              [showIcon]="true"
              placeholder="Select End Date"
              dateFormat="mm/dd/yy"
              [minDate]="startDate"
              [style]="{ width: '100%' }"
            >
            </p-calendar>
          </div>
        </div>
      </div>

      <div
        class="whiteBox table_responsive chs_members_tbl"
        *ngIf="selectedAssignmentType === 'manual'"
      >
        <p-table
          [value]="filteredTableData"
          [rows]="10"
          [showCurrentPageReport]="true"
          [paginator]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        >
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">
                <p-checkbox
                  [(ngModel)]="selectAll"
                  inputId="selectAll"
                  name="selectAll"
                  [binary]="true"
                  (onChange)="toggleSelectAll($event)"
                >
                </p-checkbox>
                <label for="selectAll">Member</label>
              </th>
              <th scope="col">Department</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-i="rowIndex">
            <tr>
              <td>
                <p-checkbox
                  [inputId]="'ingredient' + i"
                  [name]="'pizza' + i"
                  [value]="rowData.id"
                  [(ngModel)]="rowData.selected"
                  [binary]="true"
                >
                </p-checkbox>

                <label [for]="'ingredient' + i" class="ml-2">
                  <div class="user_block click_action">
                    <figure>
                      <img [src]="assetsConst.dummyProfile" alt="Profile" />
                    </figure>
                    <p>
                      <b>{{ rowData.name }}</b>
                      <span>{{ rowData.email }}</span>
                    </p>
                  </div>
                </label>
              </td>
              <td>{{ rowData.department }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="2" class="text-center">No members found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="btn_flex mt_30 spc_btwn">
        <p-button
          variant="outlined"
          label="Back"
          icon="pi pi-arrow-left"
          (click)="backToPurchaseSelection()"
          role="button"
        >
        </p-button>
        <p-button
          label="Assign Seats"
          icon="pi pi-arrow-right"
          iconPos="right"
          (click)="assignSeats()"
          [disabled]="!hasSelectedMembers()"
          role="button"
        >
        </p-button>
      </div>
    </div>
  </div>
</div>

